import { Skeleton } from "@/atoms"
import { TitleDrawer } from "@/molecules/TitleDrawer"

export const SkeletonTitle = () => (
  <TitleDrawer
    title={<Skeleton.Input active block size="large" />}
    noKaiButton
  />
)
